import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { UsersService } from "../services/user.service";
import { User } from "../models/user";

@Injectable()
export class CurrentUserResolver  {
    constructor(
        private router: Router,
        private userService: UsersService,
        private http: HttpClient)
    {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
        return this.userService.getCurrentUser();
    }
}